import recaptcha from "@wwdev/forms/recaptcha";

class Concept {
	constructor(config) {
		this.config = Object.assign({
			form: 'form[data-concept-form]',
		}, config);

		this.init();
	}

	init() {
		const form = document.querySelector(this.config.form);

		if (!form) {
			return;
		}
		form.addEventListener('submit', (event) => {
			if (form.dataset.recaptchaDone) {
				delete form.dataset.recaptchaDone;
				return; // token zit erin, submit mag doorlopen
			}

			event.preventDefault();
			event.stopImmediatePropagation();

			recaptcha($(form), (token, error) => {
				if (error) {
					console.error('reCAPTCHA failed:', error);
					return;
				}

				form.dataset.recaptchaDone = '1';
				form.requestSubmit(); // vuurt écht submit-event, vendor-flow blijft intact
			});
		}, true); // capture phase
	}
}

export default new Concept;